import { render, staticRenderFns } from "./OperatorSettings.vue?vue&type=template&id=36256024&scoped=true&"
import script from "./OperatorSettings.vue?vue&type=script&lang=js&"
export * from "./OperatorSettings.vue?vue&type=script&lang=js&"
import style0 from "./OperatorSettings.vue?vue&type=style&index=0&id=36256024&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36256024",
  null
  
)

export default component.exports